<div class="main-wrap" fxLayout="column">
    <div *ngIf="displayedScope" class="w-100">
        <div color="primary" class="question-title-index">
            {{ selection?.length ? selection.length + 1 : 1 }}
        </div>

        <ng-container [ngSwitch]="displayedScope">
            <ng-container *ngSwitchCase="AppScope.MATERIAL">
                <app-course-manager-core-add-material
                    #compRef
                    [display]="displayTab"
                    [selection]="selection"
                    (select)="addResource($event); displayedScope = null"
                    (onError)="onError.emit($event)"
                    (onCloseView)="displayedScope = null"
                    (onMultiSelect)="addMultipleResources($event); displayedScope = null"
                ></app-course-manager-core-add-material
            ></ng-container>
            <ng-container *ngSwitchCase="AppScope.TEST">
                <app-course-manager-core-add-test
                    #compRef
                    [display]="displayTab"
                    [selection]="selection"
                    (add)="addResource($event); displayedScope = null"
                    (onMultiSelect)="addMultipleResources($event); displayedScope = null"
                    (onError)="onError.emit($event)"
                    (onCloseView)="displayedScope = null"
                >
                </app-course-manager-core-add-test
            ></ng-container>
            <ng-container *ngSwitchCase="AppScope.SURVEY">
                <app-course-manager-core-add-survey
                    #compRef
                    [display]="displayTab"
                    [selection]="selection"
                    (add)="addResource($event); displayedScope = null"
                    (onMultiSelect)="addMultipleResources($event); displayedScope = null"
                    (onError)="onError.emit($event)"
                    (onCloseView)="displayedScope = null"
                ></app-course-manager-core-add-survey
            ></ng-container>
            <ng-container *ngSwitchCase="AppScope.EVENT">
                <app-course-manager-core-add-event
                    #compRef
                    [display]="displayTab"
                    [selection]="selection"
                    (add)="addResource($event); displayedScope = null"
                    (onMultiSelect)="addMultipleResources($event); displayedScope = null"
                    (onError)="onError.emit($event)"
                    (onCloseView)="displayedScope = null"
                ></app-course-manager-core-add-event
            ></ng-container>
            <ng-container *ngSwitchCase="AppScope.SCORM">
                <app-course-manager-core-add-scorm
                    #compRef
                    [display]="displayTab"
                    [selection]="selection"
                    (add)="addResource($event); displayedScope = null"
                    (onMultiSelect)="addMultipleResources($event); displayedScope = null"
                    (onError)="onError.emit($event)"
                    (onCloseView)="displayedScope = null"
                ></app-course-manager-core-add-scorm>
            </ng-container>
        </ng-container>
    </div>
    <div *ngIf="!displayedScope" fxLayout="row wrap" fxLayoutGap="10px" class="w-100 adding-btns">
        <button
            type="button"
            mat-button
            (click)="addCourseItem()"
            data-testid="course-manager-add-item"
        >
            <mat-icon>add_circle_outline</mat-icon>
            <span i18n="@@addItem">Add Item</span>
        </button>
    </div>
</div>
